<template>
  <div>
    <div id="app" v-if="roleId == '-1004'">
      <span class="basisInformation">班级管理</span>
      <el-button class="baocun" type="primary" size="medium" @click="dialogTrue"
        >添加班级</el-button
      >
      <el-divider></el-divider>
      <!-- 标签页 -->
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="item in gradeListAll"
          :key="item.id"
          :label="item.name + '(' + item.classesCount + ')'"
          :name="item.id.toString()"
        ></el-tab-pane>
        <class-table
          :curPages="1"
          @removeClass="removeClasses"
          :gradeId="gradeId + ''"
          ref="classTable"
        ></class-table>
      </el-tabs>

      <!-- 添加班级对话框 普通学校-->
      <el-dialog title="添加班级" :visible.sync="dialogVisible" width="30%">
        <div class="text">年级名称 {{ className }}</div>
        <div>新增数量：</div>
        <el-input-number
          v-model="classForm.classNum"
          :min="1"
          :max="10"
        ></el-input-number>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button size="small" type="primary" @click="addclass"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 添加班级对话框 校外机构-->
      <el-dialog title="添加班级" :visible.sync="dialogClass" width="30%">
        <el-form ref="addClass" :model="classForm">
          <el-form-item
            label="班级数量"
            :label-width="formLabelWidth"
            prop="classNum"
            :rules="[
              { required: true, message: '请输入班级数量' },
              { type: 'number', message: '班级数量必须为数字值' },
            ]"
          >
            <el-input
              v-model.number="classForm.classNum"
              style="width: 300px"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="课程类型"
            :label-width="formLabelWidth"
            prop="classType"
            :rules="[
              { required: true, message: '请输入课程类型', trigger: 'change' },
            ]"
          >
            <el-select
              v-model="classForm.classType"
              style="width: 300px"
              placeholder="请选择课程类型"
            >
              <el-option
                v-for="(item, index) in courseList"
                :label="item.typeName"
                :value="item.id"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogClass = false">取 消</el-button>
          <el-button size="small" type="primary" @click="addClassX"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 班主任进入 -->
    <teacher-class v-else></teacher-class>
  </div>
</template>
<script>
import { gradeList, addBatchcreate, selectEvaCourseType } from '@/api/home'
import ClsaaTable from './components/ClassesTable'
import LoginVue from '../../login/Login.vue'
import teacherClass from './components/teacherclass.vue'
export default {
  data() {
    return {
      gradeListAll: [],
      activeName: '',
      gradeId: 0,
      dialogVisible: false,
      dialogClass: false,
      num: 0,
      className: '',
      roleType: localStorage.getItem('roleType'),
      userId: localStorage.getItem('schoolIds'),
      totalCount: 0,
      roleId: '',
      type: '',
      typeTime: '',
      classForm: {
        classNum: 1,
        classType: '',
      },
      formLabelWidth: '120px',
      courseList: [],
      courseTypeName: '',
    }
  },
  components: {
    // 声明子组件名字
    'class-table': ClsaaTable,
    teacherClass,
  },
  created() {
    this.gradeList()
    this.selectEvaCourseType()
    this.userId = localStorage.getItem('schoolIds')
    this.roleId = localStorage.getItem('roleId')
    this.type = localStorage.getItem('type')
    // this.typeTime = setInterval(() => {
    //   this.type = localStorage.getItem('type')
    //   this.selectType()
    // }, 500);
  },
  methods: {
    // selectType(){
    //   if (this.type !== null) {
    //     clearInterval(this.typeTime)
    //   }
    // },
    // 调取班级接口 带班级数量
    async gradeList() {
      try {
        const { data: res } = await gradeList({
          schoolId: this.userId,
        })
        this.gradeListAll = res.data
        let activeName = sessionStorage.getItem('activeName')
        if (activeName > 0) {
          this.activeName = activeName
          this.gradeId = activeName
        } else {
          this.activeName = res.data[0].id.toString()
          this.gradeId = res.data[0].id
        }
      } catch (err) {
        console.log(err)
      }
    },
    // tab栏点击事件
    handleClick(e) {
      sessionStorage.setItem('activeName', this.activeName)
      this.gradeId = e.name
    },

    dialogTrue() {
      if (this.type == 8) {
        this.dialogClass = true
        return false
      }
      this.dialogVisible = true
      this.gradeListAll.forEach((item) => {
        if (this.gradeId == item.id) {
          this.className = item.name
        }
      })
    },
    addClassX() {
      this.$refs.addClass.validate((valid) => {
        if (valid) {
          this.courseList.forEach((item) => {
            if (this.classForm.classType == item.id) {
              this.courseTypeName = item.typeName
            }
          })
          this.addclass()
        } else {
          return false
        }
      })
    },
    // 添加班级
    async addclass() {
      if (this.classForm.classNum == 0) {
        this.$message.error('班级数量不能为0')
        return false
      }
      try {
        const { data: res } = await addBatchcreate({
          gradeId: this.gradeId,
          num: this.classForm.classNum,
          schoolId: this.userId,
          courseTypeId: this.classForm.classType,
          courseTypeName: this.courseTypeName,
        })
        this.dialogClass = false
        this.dialogVisible = false
        this.$refs.addClass.resetFields()
      } catch (err) {}
      this.gradeList()
      this.$refs.classTable.classesList()
    },
    //课程类型
    async selectEvaCourseType() {
      const { data: res } = await selectEvaCourseType()
      this.courseList = res.data
    },
    removeClasses() {
      this.gradeList()
    },
  },
}
</script>
<style scoped>
#app {
  position: relative;
  /* padding-top: 20px; */
}

.basisInformation {
  font-size: 16px;
  font-weight: 700;
  margin-top: 10px;
}

.el-divider {
  margin-top: 18px;
  margin-bottom: 8px;
}

.baocun {
  position: absolute;
  right: 0;
  top: -8px;
}

.el-dialog .text {
  /* display: inline; */
  height: 40px;
  width: 450px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/school/components/Classes.vue